var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.69 16.75H7.03999C6.04999 16.75 5.09999 16.33 4.42999 15.6C3.75999 14.87 3.42 13.89 3.5 12.9L4.33 2.94C4.36 2.63 4.24999 2.33001 4.03999 2.10001C3.82999 1.87001 3.54 1.75 3.23 1.75H1.5C1.09 1.75 0.75 1.41 0.75 1C0.75 0.59 1.09 0.25 1.5 0.25H3.24001C3.97001 0.25 4.65999 0.559996 5.14999 1.09C5.41999 1.39 5.62 1.74 5.73 2.13H18.22C19.23 2.13 20.16 2.53 20.84 3.25C21.51 3.98 21.85 4.93 21.77 5.94L21.23 13.44C21.12 15.27 19.52 16.75 17.69 16.75ZM5.78 3.62L5 13.02C4.95 13.6 5.14 14.15 5.53 14.58C5.92 15.01 6.45999 15.24 7.03999 15.24H17.69C18.73 15.24 19.67 14.36 19.75 13.32L20.29 5.82001C20.33 5.23001 20.14 4.67001 19.75 4.26001C19.36 3.84001 18.82 3.60999 18.23 3.60999H5.78V3.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 21.75C14.65 21.75 13.75 20.85 13.75 19.75C13.75 18.65 14.65 17.75 15.75 17.75C16.85 17.75 17.75 18.65 17.75 19.75C17.75 20.85 16.85 21.75 15.75 21.75ZM15.75 19.25C15.47 19.25 15.25 19.47 15.25 19.75C15.25 20.03 15.47 20.25 15.75 20.25C16.03 20.25 16.25 20.03 16.25 19.75C16.25 19.47 16.03 19.25 15.75 19.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 21.75C6.65 21.75 5.75 20.85 5.75 19.75C5.75 18.65 6.65 17.75 7.75 17.75C8.85 17.75 9.75 18.65 9.75 19.75C9.75 20.85 8.85 21.75 7.75 21.75ZM7.75 19.25C7.47 19.25 7.25 19.47 7.25 19.75C7.25 20.03 7.47 20.25 7.75 20.25C8.03 20.25 8.25 20.03 8.25 19.75C8.25 19.47 8.03 19.25 7.75 19.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.75H8.5C8.09 7.75 7.75 7.41 7.75 7C7.75 6.59 8.09 6.25 8.5 6.25H20.5C20.91 6.25 21.25 6.59 21.25 7C21.25 7.41 20.91 7.75 20.5 7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppMenuIcon);
export default __webpack_public_path__ + "static/media/shoppMenuIcon.4a700bd3840184f78834cc846244abf4.svg";
export { ForwardRef as ReactComponent };